import { createRequest, RequestConfig } from '../../../core/libs/api';
import { NewBookSeat } from '../types';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/book_pay_seat',
};

export const bookPaySeatRequest = (newPay: NewBookSeat) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(newPay),
  });
